export const advisor_types_api = {
    URI: `${process.env.BASE_URL}/api/advisor-types`,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    },
    auth: {
      username: process.env.AUTH_USER,
      password: process.env.AUTH_PASSWORD
    }
};

export const advisors_api = {
    URI: `${process.env.BASE_URL}/api/advisors`,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    },
    auth: {
      username: process.env.AUTH_USER,
      password: process.env.AUTH_PASSWORD
    }
};

export const advisor_api = {
    URI: `${process.env.BASE_URL}/api/advisor`,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    },
    auth: {
      username: process.env.AUTH_USER,
      password: process.env.AUTH_PASSWORD
    }
};

export const locations_api = {
  URI: `${process.env.BASE_URL}/api/locations`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
  auth: {
    username: process.env.AUTH_USER,
    password: process.env.AUTH_PASSWORD
  }
};

export const location_api = {
  URI: `${process.env.BASE_URL}/api/location`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
  auth: {
    username: process.env.AUTH_USER,
    password: process.env.AUTH_PASSWORD
  }
};

export const consumer_direct = {
  URI: `${process.env.BASE_URL}/api/consumerdirect-advisors`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
  auth: {
    username: process.env.AUTH_USER,
    password: process.env.AUTH_PASSWORD
  }
};